var Schema = require("lib/shared/Schema");
var APIClient = require("lib/web/APIClient");
var ActionUtility = require("lib/shared/ActionUtility");
var RosterSelectors = require("lib/selectors/RosterSelectors");
var SelectorUtility = require("lib/shared/SelectorUtility");
var Queries = require("lib/shared/Queries");
var CurrentUser = require("lib/account/CurrentUser");

////////////////////////////////////////
// Bulk fetch //////////////////////////
////////////////////////////////////////

export const GLOBAL_STUDENT_EMBEDS = [
	"student.prefs", "student.avatar", "student.student_list_ids", "student.primary_student_list_id",
	"student.current_reading_level", "student.expectations_date_spans", "student.password", "student.sso_data", "student.student_list_ids"
]

export const GLOBAL_STUDENT_LIST_EMBEDS = [
	["student_list.expectations_date_spans", "student_list.passphrase", "student_list.school", "student_list.prefs", "student_list.student_ids", "student_list.admin_ids"]
]


// Fetches all school and district data the admin account (current user) needs
export function fetchOrgData() {
	return (dispatch, getState) => { // I'll need getState for CurrentUser... someday
		var fetchPromises = [];

		if (CurrentUser.isAdmin()) {
			fetchPromises.push(dispatch(fetchAdmins({
				embeds: [
					"admin.org_ids", "admin.prefs"
				]
			})));
		}

		if (CurrentUser.isDistrictAdmin()) {
			fetchPromises.push(dispatch(fetchSchoolOrgs({
				embeds: [
					"school_org.prefs"
				]
			})));
		}
		return Promise.all(fetchPromises);
	}
}

// Fetches all roster data the admin account (current user) needs
export function fetchRosterData() {
	return (dispatch, getState) => { // I'll need getState for CurrentUser... someday
		var fetchPromises = [];

		// if (CurrentUser.isAdmin() && CurrentUser.isTeacherAdmin()) {
			// Fetch students
			fetchPromises.push(dispatch(fetchStudents({
				embeds: GLOBAL_STUDENT_EMBEDS
			})));

			// Fetch student lists in batches for large accounts
			if (_.size(CurrentUser.get().student_list_ids) > 35) {
				var chunkedSLs = _.chunk(CurrentUser.get().student_list_ids, 35)
				_.each(chunkedSLs, (chunk, i) => {
					fetchPromises.push(dispatch(fetchStudentLists({
						conditions: { slIDs: chunk },
						embeds: ["student.prefs", "student_list.students", "student_list.prefs", "student_list.expectations_date_spans", "student_list.admins"]
					})));
				})
			} else {
				// Fetch student lists all at once batches for smaller accounts
				fetchPromises.push(dispatch(fetchStudentLists({
					embeds: ["student.prefs", "student_list.students", "student_list.prefs", "student_list.expectations_date_spans", "student_list.admins"]
				})));
			}
		// }

		// if (CurrentUser.isSchoolAdmin() || CurrentUser.isDistrictAdmin()) {
		// 	fetchPromises.push(dispatch(fetchAdmins({
		// 		embeds: [
		// 			"admin.org_ids", "admin.prefs"
		// 		]
		// 	})));
		// }

		// if (CurrentUser.isDistrictAdmin()) {
		// 	fetchPromises.push(dispatch(fetchSchoolOrgs({
		// 		embeds: [
		// 			"school_org.prefs"
		// 		]
		// 	})));
		// }
		return Promise.all(fetchPromises);
	}
}

////////////////////////////////////////
// Admins //////////////////////////////
////////////////////////////////////////

export function fetchAdmins({ filters, conditions, loading, embeds, cache }) {

	var params = Queries.toQuery(filters, conditions);


	return (dispatch) => {
		return dispatch(ActionUtility.fetchRecords(
			APIClient.getAdmins,
			{ admins: [Schema.ADMIN] }, 
			{ params, embeds },
			{ reducer: "admins", loading: loading || "index", cache }
		));
	}
}

export function updateAdmin({ id, update, embeds, query }) {
	var params = _.extend({}, query, { admin: update });

	return (dispatch) => {
		dispatch({ type: ActionUtility.UPDATE_RECORDS, admins: [id], update: update });

		return dispatch(ActionUtility.fetchRecords(
			APIClient.patchAdmin.bind(null, id),
			{ admin: Schema.ADMIN },
			{ params, embeds },
			{ reducer: "admins", loading: "update" }
		))
	}
}

export function createAdmin({ admin, embeds, query, subAdmins }) {
	var params = _.extend({}, query, { admin: admin });

	if (subAdmins) {
		params.sub_admins = subAdmins;
	}

	return (dispatch) => {

		return dispatch(ActionUtility.fetchRecords(
			APIClient.postAdmins,
			{ admin: Schema.ADMIN },
			{ embeds, params, query },
			{ reducer: "admins", loading: "create" }
		))
	}
}

export function clearAdmins({ }) {
	return (dispatch) => {
		return dispatch({ type: ActionUtility.REMOVE_ALL_RECORDS, admins: true });
	}
}

////////////////////////////////////////
// Awards //////////////////////////////
////////////////////////////////////////

export function createAward({ award }) {
	return (dispatch) => {
		return APIClient.postAwards({ award: award });
	}
}

////////////////////////////////////////
// Discount Tokens /////////////////////
////////////////////////////////////////

export function fetchDiscountToken({ code, query }) {
	var params = _.extend({}, query);

	return (dispatch) => {
		return dispatch(ActionUtility.fetchRecord(
			APIClient.getDiscountToken,
			code,
			{ discount_token: Schema.DISCOUNT_TOKEN },
			{ params },
			{ reducer: "discountTokens", loading: code }));
	}
}

export function fetchDiscountTokens({ filters, conditions, embeds, cache, loading }) {
	var params = Queries.toQuery(filters, conditions);
	return (dispatch) => {
		return dispatch(ActionUtility.fetchRecords(
			APIClient.getDiscountTokens,
			{ discount_tokens: [Schema.DISCOUNT_TOKEN] }, 
			{ params, embeds },
			{ reducer: "discountTokens", loading: (loading || "index"), cache }
		));
	}
}

export function createDiscountTokens({ discountTokens, embeds }) {
	var params = { discount_tokens: discountTokens };

	return (dispatch) => {
		return dispatch(ActionUtility.fetchRecords(
			APIClient.postDiscountTokens,
			{ discount_tokens: [Schema.DISCOUNT_TOKENS] },
			{ embeds, params },
			{ reducer: "discountTokens", loading: "create" }
		))
	}
}

export function updateDiscountToken({ id, update, embeds, query }) {
	var params = _.extend({}, query, { discount_token: update });

	return (dispatch) => {
		dispatch({ type: ActionUtility.UPDATE_RECORDS, discountTokens: [id], update: update });

		return dispatch(ActionUtility.fetchRecords(
			APIClient.patchDiscountToken.bind(null, id),
			{ discount_token: [Schema.DISCOUNT_TOKEN] },
			{ params, embeds },
			{ reducer: "discountTokens", loading: "update" }
		))
	}
}

export function deleteDiscountToken({ id }) {
	return (dispatch) => {
		APIClient.deleteDiscountToken(id);
		return dispatch({ type: ActionUtility.REMOVE_RECORDS, discountTokens: [id] });
	}
}

export function clearDiscountTokens({ }) {
	return (dispatch) => {
		return dispatch({ type: ActionUtility.REMOVE_ALL_RECORDS, discountTokens: true });
	}
}


////////////////////////////////////////
// DistrictOrgs ////////////////////////
////////////////////////////////////////

export function createDistrictOrg({ districtOrg, embeds }) {
	var params = { district_org: districtOrg };

	return (dispatch) => {
		return dispatch(ActionUtility.fetchRecords(
			APIClient.postDistrictOrgs,
			{ district_org: Schema.DISTRICT_ORG },
			{ embeds, params },
			{ reducer: "districtOrgs", loading: "create" }
		))
	}
}


////////////////////////////////////////
// Prefs ///////////////////////////////
////////////////////////////////////////

export function updateAdminPrefs({ id, update, resetStudentLists, embeds, query }) {

	return (dispatch, getState) => {
		// LOCAL ADMIN update
		var admin = getState().admins[id];
		if (admin) {
			var updatedPrefs = _.extend({}, admin.prefs, update)
			dispatch({ type: ActionUtility.UPDATE_RECORDS,
				admins: [id], update: { prefs: updatedPrefs } });			
		}

		// LOCAL STUDENTLIST UPDATE
		if (resetStudentLists) {
			var studentLists = RosterSelectors.studentListsByAdminId({ state: getState(), adminId: id });
			if (!_.isEmpty(studentLists)) {
				_.each(studentLists, (studentList) => {
					// SET STUDENT LIST PREF TO ADMIN PREF | FORCE RESET OF STUDENTS WITH TRUE
					localStudentListPrefsUpdate(dispatch, getState, studentList, update, true);
				})
			}
		}
		
		// REMOTE update
		var params = _.extend({}, query, { admin: { prefs: update } });
		if (resetStudentLists) {
			params.admin.reset_student_list_prefs = _.keys(update);
			params.admin.reset_student_prefs = _.keys(update);
		}

		return dispatch(ActionUtility.fetchRecords(
			APIClient.patchAdmin.bind(null, id),
			{ student: Schema.ADMIN },
			{ params, embeds },
			{ reducer: "admins", loading: "update" }
		))
	}

	var params = _.extend({}, query, { admin: update });
}

export function updateStudentPrefs({ studentID, update, embeds, query }) {
	// We need to split out the updates. We want to PATCH the prefs on their own
	// but we want to merge them into all the other student prefs locally

	return (dispatch, getState) => {
		// LOCAL update
		var student = getState().students[studentID];
		if (student) {
			localStudentPrefsUpdate(dispatch, student, update);		
		}


		// REMOTE update
		var params = _.extend({}, query, { student: { prefs: update } });
		return dispatch(ActionUtility.fetchRecords(
			APIClient.patchStudent.bind(null, studentID),
			{ student: Schema.STUDENT },
			{ params, embeds },
			{ reducer: "students", loading: "update" }
		))
	}
}

export function massUpdateStudentPrefs({ studentIDs, subgroupKey, update, embeds, query }) {
	// We need to split out the updates. We want to PATCH the prefs on their own
	// but we want to merge them into all the other student prefs locally

	return (dispatch, getState) => {
		if (!studentIDs && subgroupKey) {
			var students = RosterSelectors.studentsForSubgroupKey({ state: getState(), subgroupKey });
			studentIDs = _.pluck(students, "id");
		} else {
			var students = _.values(_.pick(getState().students, studentIDs));						
		}

		// LOCAL update
		_.each(students, (student) => {
			localStudentPrefsUpdate(dispatch, student, update);
		});

		// REMOTE update
		var params = _.extend({ mass_update: true }, query, { students: { prefs: update } });
		return dispatch(ActionUtility.fetchRecords(
			APIClient.patchStudent.bind(null, studentIDs.join(",")),
			{ students: [Schema.STUDENT] },
			{ params, embeds },
			{ reducer: "students", loading: "update" }
		))
	}
}

export function updateStudentList({ id, update, embeds, query }) {
	var params = _.extend({}, query, { student_list: update });

	return (dispatch, getState) => {
		dispatch({
			type: ActionUtility.UPDATE_RECORDS,
			studentLists: [id],
			update: _.omit(update, "prefs")
		});

		// Update prefs on their own
		var studentList = getState().studentLists[id];
		if (studentList && update.prefs) {
			localStudentListPrefsUpdate(dispatch, getState, studentList, update, false);	
		}

		return dispatch(ActionUtility.fetchRecords(
			APIClient.patchStudentList.bind(null, id),
			{ student: Schema.STUDENT_LIST },
			{ params, embeds },
			{ reducer: "studentList", loading: "update" }
		))
	}
}

export function postUserTrigger(user_id, params) {
	return (dispatch) => {
		return APIClient.postUserTrigger(user_id, params);
	}
}

export function updateStudentListPrefs({ studentListID, resetStudents, update, embeds, query }) {
	
	return (dispatch, getState) => {
		// LOCAL update
		var studentList = getState().studentLists[studentListID];
		if (studentList) {
			localStudentListPrefsUpdate(dispatch, getState, studentList, update, resetStudents);		
		}
		
		// // REMOTE update
		var params = _.extend({}, query, { student_list: { prefs: update } });
		if (resetStudents) {
			params.student_list.reset_student_prefs = _.keys(update);
		}
		return dispatch(ActionUtility.fetchRecords(
			APIClient.patchStudentList.bind(null, studentListID),
			{ studentList: Schema.STUDENT_LIST },
			{ params, embeds },
			{ reducer: "studentLists", loading: "update" }
		))
	}
}

export function updateAllStudentListPrefs({ currentUserID, resetStudents, update, embeds, query }) {

	return (dispatch, getState) => {
		// LOCAL update
		var studentLists = SelectorUtility.allRecords(getState().studentLists);
		if (!_.isEmpty(studentLists)) {
			_.each(studentLists, (studentList) => {
				localStudentListPrefsUpdate(dispatch, getState, studentList, update, resetStudents);
			})
		}
		
		// REMOTE update
		var params = _.extend({}, query, { admin: { all_student_list_prefs: update } });
		if (resetStudents) {
			params.admin.reset_student_prefs = _.keys(update);
		}
		return dispatch(ActionUtility.fetchRecords(
			APIClient.patchAdmin.bind(null, currentUserID),
			{ admin: Schema.ADMIN },
			{ params, embeds },
			{ reducer: "admins", loading: "update" }
		))
	}
}

export function archiveStudentList({ id }) {
	return (dispatch) => {
		APIClient.deleteStudentList(id, { archive: true });
		return dispatch({ type: ActionUtility.REMOVE_RECORDS, studentLists: [id] });
	}
}

export function updateDistrictOrgPrefs({ currentUserID, districtOrgID, resetPrefs, update, embeds, query }) {
	return (dispatch, getState) => {
		// LOCAL update
		var districtOrg = getState().districtOrgs[districtOrgID];
		if (districtOrg) {
			localDistrictOrgPrefsUpdate(dispatch, getState, districtOrg, update, resetPrefs)			
		}
		 // ADD SCHOOL, STUDENTLIST AND ADMIN's preferences update

		// // REMOTE update
		var params = _.extend({}, query, { user_id: currentUserID, district_org: { prefs: update } });
		if (resetPrefs) {
			params.district_org.reset_prefs = _.keys(update);
		}

		return dispatch(ActionUtility.fetchRecords(
			APIClient.patchDistrictOrg.bind(null, districtOrgID),
			{ districtOrgID: Schema.DISTRICT_ORG },
			{ params, embeds },
			{ reducer: "district_org", loading: "update" }
		))
	}
}

export function updateSchoolOrgPrefs({ currentUserID, schoolOrgID, resetPrefs, update, embeds, query }) {
	return (dispatch, getState) => {
		
		//LOCAL UPDATE
		var schoolOrg = getState().schoolOrgs[schoolOrgID];
		if (schoolOrg) {
			localSchoolOrgPrefsUpdate(dispatch, getState, schoolOrg, update, resetPrefs)			
		}
		
		// REMOTE update
		var params = _.extend({}, query, { user_id: currentUserID, school_org: { prefs: update } });
		if (resetPrefs) {
			params.school_org.reset_prefs = _.keys(update);
		}

		return dispatch( ActionUtility.fetchRecords(
			APIClient.patchSchoolOrg.bind(null, schoolOrgID),
			{ schoolOrgID: Schema.SCHOOL_ORG },
			{ params, embeds },
			{ reducer: "school_org", loading: "update" }
		))
	}
}

/// LOCAL UPDATES FOR PREFS
function localGeneralPrefUpdate(dispatch, getState, update) {
	
	_.each( _.values(getState().school_orgs), (schoolOrg) => {
		localSchoolOrgPrefsUpdate(dispatch, getState, schoolOrg, update, false)
	})

	_.each( _.values(getState().admins), (admin) => {
		localAdminPrefsUpdate(dispatch, admin, update)
	})

	_.each( _.values(getState().student_lists), (studentList) => {
		localStudentListPrefsUpdate(dispatch, getState, studentList, update, false)
	})

	_.each( _.values(getState().students), (student) => {
		localStudentPrefsUpdate(dispatch, student, update, false)
	})
}

function localDistrictOrgPrefsUpdate(dispatch, getState, districtOrg, update, resetPrefs) {				
	var updatedPrefs = _.extend({}, districtOrg.prefs, update)
	dispatch({ type: ActionUtility.UPDATE_RECORDS,
		districtOrgs: [districtOrg.id], update: { prefs: updatedPrefs } });

	// LOCAL GENERAL UPDATE
	if (resetPrefs) {
		localGeneralPrefUpdate(dispatch, getState, update) 
	}
}

function localSchoolOrgPrefsUpdate(dispatch, getState, schoolOrg, update, resetPrefs) {				

	// LOCAL GENERAL UPDATE
	if (resetPrefs) {
		localGeneralPrefUpdate(dispatch, getState, update) 
	} else {
		var updatedPrefs = _.extend({}, schoolOrg.prefs, update)
		dispatch({ type: ActionUtility.UPDATE_RECORDS,
		schoolOrgs: [schoolOrg.id], update: { prefs: updatedPrefs } });
	}
}

function localAdminPrefsUpdate(dispatch, admin, update) {
	var updatedPrefs = _.extend({}, admin.prefs, update)
	dispatch({ type: ActionUtility.UPDATE_RECORDS,
		admins: [admin.id], update: { prefs: updatedPrefs } });
}

function localStudentListPrefsUpdate(dispatch, getState, studentList, update, resetStudents) {
	var updatedPrefs = _.extend({}, studentList.prefs, update)
	dispatch({ type: ActionUtility.UPDATE_RECORDS,
		studentLists: [studentList.id], update: { prefs: updatedPrefs } });

	if (resetStudents) {
		var students = RosterSelectors.studentsForStudentListID({ state: getState(),  studentListID: studentList.id });
		if (!_.isEmpty(students)) {
			_.each(students, (student) => {
				localStudentPrefsUpdate(dispatch, student, update);
			})
		}
	}
}

function localStudentPrefsUpdate(dispatch, student, update) {
	var updatedPrefs = _.extend({}, student.prefs, update)
	dispatch({ type: ActionUtility.UPDATE_RECORDS,
		students: [student.id], update: { prefs: updatedPrefs } });
}

////////////////////////////////////////
// Referrals ///////////////////////////
////////////////////////////////////////

export function postReferrals({ referral }) {
	return (dispatch) => {
		return APIClient.postReferrals({ referral });
	}
}

////////////////////////////////////////
// Schools ////////////////////////
////////////////////////////////////////

export function fetchSchool({ id, embeds, query }) {
	var params = _.extend({}, query);
	return (dispatch) => {
		return dispatch(ActionUtility.fetchRecord(
			APIClient.getSchool,
			id,
			{ school: Schema.SCHOOL },
			{ embeds, params },
			{ reducer: "schools", loading: id }));
	}
}

export function createSchool({ school, embeds }) {
	var params = { school };

	return (dispatch) => {
		return dispatch(ActionUtility.fetchRecords(
			APIClient.postSchools,
			{ school: Schema.SCHOOL },
			{ embeds, params },
			{ reducer: "schools", loading: "create" }
		))
	}
}

////////////////////////////////////////
// Rosters /////////////////////////////
////////////////////////////////////////

export function postRosters({ studentsData, noBackground, effectiveUserID }) {
	return (dispatch) => {
		const data = {
			students_data: studentsData,
			no_background: noBackground
		}
		if (effectiveUserID) {
			data.effective_user_id = effectiveUserID;
		}
		return APIClient.postRosters(data);
	}
}

////////////////////////////////////////
// SchoolOrgs ////////////////////////
////////////////////////////////////////

export function fetchSchoolOrgs({ filters, conditions, embeds, cache }) {
	var params = Queries.toQuery(filters, conditions);

	return (dispatch) => {
		return dispatch(ActionUtility.fetchRecords(
			APIClient.getSchoolOrgs,
			{ school_orgs: [Schema.SCHOOL_ORG] }, 
			{ params, embeds },
			{ reducer: "schoolOrgs", loading: "index", cache }
		));
	}
}

export function fetchSchoolOrgsPaginated({ filters, conditions, embeds, cache, page }) {
	var params = Queries.toQuery(filters, conditions);
	var pagination = { key: $wr.sortedJSON(params), page };
	return (dispatch) => {
		return dispatch(ActionUtility.fetchRecords(
			APIClient.getSchoolOrgs,
			{ school_orgs: [Schema.SCHOOL_ORG] },
			{ params, embeds },
			{ reducer: "schoolOrgs", loading: "index", cache, pagination }
		));
	}
}

export function createSchoolOrg({ schoolOrg, embeds }) {
	var params = { school_org: schoolOrg };

	return (dispatch) => {
		return dispatch(ActionUtility.fetchRecords(
			APIClient.postSchoolOrgs,
			{ school_org: Schema.SCHOOL_ORG },
			{ embeds, params },
			{ reducer: "schoolOrgs", loading: "create" }
		))
	}
}

////////////////////////////////////////
// DistrictOrgs ////////////////////////
////////////////////////////////////////

export function fetchDistrictOrgs({ filters, conditions, embeds, cache }) {
	var params = Queries.toQuery(filters, conditions);

	return (dispatch) => {
		return dispatch(ActionUtility.fetchRecords(
			APIClient.getDistrictOrgs,
			{ district_orgs: [Schema.DISTRICT_ORG] }, 
			{ params, embeds },
			{ reducer: "districtOrgs", loading: "index", cache }
		));
	}
}

export function fetchDistrictOrgsPaginated({ filters, conditions, embeds, cache, page }) {
	var params = Queries.toQuery(filters, conditions);
	var pagination = { key: $wr.sortedJSON(params), page };
	return (dispatch) => {
		return dispatch(ActionUtility.fetchRecords(
			APIClient.getDistrictOrgs,
			{ district_orgs: [Schema.DISTRICT_ORG] },
			{ params, embeds },
			{ reducer: "districtOrgs", loading: "index", cache, pagination }
		));
	}
}


////////////////////////////////////////
// StudentLists ////////////////////////
////////////////////////////////////////

export function fetchStudentLists({ filters, conditions, loading, embeds, cache }) {
	var params = Queries.toQuery(filters, conditions);
	return (dispatch) => {
		return dispatch(ActionUtility.fetchRecords(
			APIClient.getStudentLists,
			{ student_lists: [Schema.STUDENT_LIST] }, 
			{ params, embeds },
			{ reducer: "studentLists", loading: loading || "index", cache }
		));
	}
}

export function fetchStudentListsStoreless({ query }) {
	return (dispatch) => {
		return APIClient.getStudentLists(query)
	}
}


export function fetchStudentList({ id, embeds, query, cache }) {
	var params = _.extend({}, query);

	return (dispatch) => {
		return dispatch(ActionUtility.fetchRecord(
			APIClient.getStudentList,
			id,
			{ student_list: Schema.STUDENT_LIST }, 
			{ params, embeds },
			{ reducer: "studentLists", loading: id, cache: cache }
		));
	}
}

export function invalidateStudentListCache({}) {
	return (dispatch) => {
		return dispatch({ type: ActionUtility.INVALIDATE_CACHE, studentLists: true })
	}
}

export function postStudentLists({ studentLists, embeds }) {
	return (dispatch) => {
		return APIClient.postStudentLists({ student_lists: studentLists, embeds });
	}
}

export function clearStudentLists({ }) {
	return (dispatch) => {
		return dispatch({ type: ActionUtility.REMOVE_ALL_RECORDS, studentLists: true });
	}
}

////////////////////////////////////////
// Students ////////////////////////////
////////////////////////////////////////

export function fetchStudents({ filters, conditions, embeds, loading, cache }) {
	var params = Queries.toQuery(filters, conditions);

	return (dispatch) => {
		return dispatch(ActionUtility.fetchRecords(
			APIClient.getStudents,
			{ students: [Schema.STUDENT] }, 
			{ params, embeds },
			{ reducer: "students", loading: loading || 'index', cache }
		));
	}
}

export function fetchStudent({ id, embeds, query }) {
	var params = _.extend({}, query);
	return (dispatch) => {
		return dispatch(ActionUtility.fetchRecord(
			APIClient.getStudent,
			id,
			{ student: Schema.STUDENT },
			{ embeds, params },
			{ reducer: "students", loading: id }));
	}
}

export function updateStudent({ id, update, embeds, query }) {
	var params = _.extend({}, query, { student: update });

	return (dispatch, getState) => {
		dispatch({
			type: ActionUtility.UPDATE_RECORDS,
			students: [id],
			update: _.omit(update, "prefs")
		});

		// Update prefs on their own
		var student = getState().students[id];
		if (student && update.prefs) {
			var updatedPrefs = _.extend({}, student.prefs, update.prefs)
			dispatch({
				type: ActionUtility.UPDATE_RECORDS,
				students: [id],
				update: { prefs: updatedPrefs }
			});			
		}

		return dispatch(ActionUtility.fetchRecords(
			APIClient.patchStudent.bind(null, id),
			{ student: Schema.STUDENT },
			{ params, embeds },
			{ reducer: "students", loading: "update" }
		))
	}
}

// updates multiple students
export function updateStudents({ studentIDs, updates, embeds, query }) {
	var params = _.extend({}, query, { student_ids: studentIDs, updates: updates });

	return (dispatch) => {
		dispatch({ type: ActionUtility.UPDATE_RECORDS, updates: updates });

		return dispatch(ActionUtility.fetchRecords(
			APIClient.patchStudents,
			{ students: [Schema.STUDENT] },
			{ params, embeds },
			{ reducer: "students", loading: "update" }
		))
	}
}

// destroys multiple students
export function destroyStudents({ studentIDs, embeds, query }) {
	var params = _.extend({}, query, { student_ids: studentIDs, destroy: true });

	return (dispatch) => {
		dispatch({ type: ActionUtility.UPDATE_RECORDS, destroy: true });

		return dispatch(ActionUtility.fetchRecords(
			APIClient.patchStudents,
			{ students: [Schema.STUDENT] },
			{ params, embeds },
			{ reducer: "students", loading: "delete" }
		))
	}
}

// removes students from student lists
export function deleteStudents({ id, slIDs }) {
	return (dispatch) => {
		dispatch({ type: ActionUtility.REMOVE_RECORDS, students: [id]});
		return APIClient.deleteStudent(id, { student_list_ids: slIDs });
	}
}

export function clearStudents({ }) {
	return (dispatch) => {
		return dispatch({ type: ActionUtility.REMOVE_ALL_RECORDS, students: true });
	}
}

////////////////////////////////////////
// Parents ////////////////////////////
////////////////////////////////////////

export function fetchParent({ id, embeds, query }) {
	var params = _.extend({}, query);
	return (dispatch) => {
		return dispatch(ActionUtility.fetchRecord(
			APIClient.getParent,
			id,
			{ parent: Schema.PARENT },
			{ embeds, params },
			{ reducer: "parents", loading: id }));
	}
}

export function createParents({ studentIDs, parentEmails, embeds, query }) {
	var params = _.extend({}, query, {
		parents: { student_ids: studentIDs, auth_emails: parentEmails }
	});

	return (dispatch) => {
		return dispatch(ActionUtility.fetchRecords(
			APIClient.postParents,
			{ parents: [Schema.PARENT] }, // Currently, this happens in a background job, so no data
			{ embeds, params },
			{ reducer: "parents", loading: "create" }
		))
	}
}

export function updateParent({ id, update, embeds, query }) {
	var params = _.extend({}, query, { parent: update });

	return (dispatch) => {
		dispatch({ type: ActionUtility.UPDATE_RECORDS, parents: [id], update: update });

		return dispatch(ActionUtility.fetchRecords(
			APIClient.patchParent.bind(null, id),
			{ parent: Schema.PARENT },
			{ params, embeds },
			{ reducer: "parents", loading: "update" }
		))
	}
}

////////////////////////////////////////
// Upgrade Tokens //////////////////////
////////////////////////////////////////

export function fetchUpgradeTokens({ filters, conditions, embeds, cache, loading }) {
	var params = Queries.toQuery(filters, conditions);

	return (dispatch) => {
		return dispatch(ActionUtility.fetchRecords(
			APIClient.getUpgradeTokens,
			{ upgrade_tokens: [Schema.UPGRADE_TOKEN] }, 
			{ params, embeds },
			{ reducer: "upgradeTokens", loading: (loading || "index"), cache }
		));
	}
}

export function updateUpgradeToken({ id, update, embeds, query }) {
	var params = _.extend({}, query, { upgrade_token: update });

	return (dispatch) => {
		dispatch({ type: ActionUtility.UPDATE_RECORDS, upgradeTokens: [id], update: update });

		return dispatch(ActionUtility.fetchRecords(
			APIClient.patchUpgradeToken.bind(null, id),
			{ upgrade_token: [Schema.UPGRADE_TOKEN] },
			{ params, embeds },
			{ reducer: "upgradeTokens", loading: "update" }
		))
	}
}

export function clearUpgradeTokens({}) {
	return (dispatch) => {
		return dispatch({ type: ActionUtility.REMOVE_ALL_RECORDS, upgradeTokens: true });
	}
}

export function createUpgradeTokens({ upgradeTokens, embeds }) {
	var params = { upgrade_tokens: upgradeTokens };

	return (dispatch) => {
		return dispatch(ActionUtility.fetchRecords(
			APIClient.postUpgradeTokens,
			{ upgrade_tokens: [Schema.UPGRADE_TOKEN] },
			{ embeds, params },
			{ reducer: "upgradeTokens", loading: "create" }
		))
	}
}

export function deleteUpgradeToken({ id }) {
	return (dispatch) => {
		APIClient.deleteUpgradeToken(id);
		return dispatch({ type: ActionUtility.REMOVE_RECORDS, upgradeTokens: [id] });
	}
}

////////////////////////////////////////
// Users ///////////////////////////////
////////////////////////////////////////

export function fetchUsersStoreless({ query }) {
	return APIClient.getUsers(query);
}

export function mergeStudents({ mapping }) {
	return APIClient.postStudentsMerge({ mapping });
}


////////////////////////////////////////
// Notifications ///////////////////////
////////////////////////////////////////

export function createUserAlerts({ on, userAlert }) {
	return (dispatch) => {
		return APIClient.postUserAlerts({ user_alert: userAlert, on });
	}
}


// WEBPACK FOOTER //
// ./modules/lib/actions/RosterActions.js